<template>
  <section class="index">
    <IndexFace />

    <SliderTest
      v-if="cities.length"
      :cities="cities"
    />

    <transition
      @enter="enter"
    >
      <FooterLegend v-if="entered" />
    </transition>

    <transition
      @enter="enter"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 113"
        class="arrow-svg arrow-scroll"
        v-show="entered"
        @click="clickArrow"
      >
        <path
          d="M50 112l-4.1-3.6L1 70l8.3-9.7 34.3 29.4V1h12.8v88.7l34.3-29.4L99 70l-44.9 38.4L50 112z"
          fill="none"
          stroke="#fff"
          stroke-dasharray="450"
          stroke-dashoffset="900"
        />
      </svg>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import gsap from 'gsap';

import SliderTest from '@/components/SliderTest';
import IndexFace from '@/components/IndexFace';
import FooterLegend from '@/components/FooterLegend';


export default {
  name: 'home',

  components: {
    SliderTest,
    IndexFace,
    FooterLegend,
  },

  computed: {
    ...mapGetters(['getCities']),
  },

  data() {
    return {
      cities: [],
      entered: false,
    };
  },

  mounted() {
    this.entered = true;
    this.emptyFunction = () => {};
    document.addEventListener('keydown', this.emptyFunction);
  },

  created() {
    if (this.$store.getters.getCities.length < 1) {
      this.$store.dispatch('FETCH_CITIES').then(() => {
        console.log('CITIES FETCHED 😃');
        this.cities = this.getCities;
      });
    } else {
      console.log('CITIES RETRIEVE FROM STORE 🤘');
      this.cities = this.getCities;
    }
  },

  methods: {
    enter(el, done) {
      gsap.fromTo(el, 1, {
        yPercent: -20,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
        ease: gsap.Expo.easeOut,
        clearProps: 'all',
        delay: 1,
        onComplete: done,
      });
    },

    clickArrow() {
      const e = new KeyboardEvent('keydown', { keyCode: 39, which: 39 });
      document.dispatchEvent(e);
    },
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.emptyFunction);
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

:global {
  @keyframes bounce {
    0% {
      transform-origin: 50% 0;
      transform: translateX(0) scaleX(1) rotate(-90deg);
    }

    10% {
      transform-origin: 50% 0;
      transform: translateX(10%) scaleX(1.05) rotate(-90deg);
    }

    20% {
      transform-origin: 50% 0;
      transform: translateX(0) scaleX(1) rotate(-90deg);
    }

    100% {
      transform-origin: 50% 0;
      transform: translateX(0) scaleX(1) rotate(-90deg);
    }
  }
}

.index {
  display: inline-block;

  .arrow-svg {
    display: inline-block;
    position: fixed;
    right: 75px;
    bottom: 0;
    width: 60px;

    transform-origin: 50% 0;
    transform: rotate(-90deg);
    animation: bounce 5s infinite forwards 3s;

    @include mq(sm) {
      right: 140px;
      bottom: 0px;
      width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue